export default "__VITE_ASSET__BxeEd4cP__"